import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { getSvgIcon } from '@telialt/common-icon/src';
import { VasProduct } from '@telialt/models/src/EshopModel';
import { DataTest } from '@telialt/utils/src/helpers';
import { useComponentId } from '@telialt/utils/src/hooks';

import { IconMd, TextWithIcon, VasBlockContainer } from './ValueAddedServices.styles';

type Props = { vasList: VasProduct[] } & DataTest;

export const VasBlock: FC<Props> = ({ vasList, dataTest }) => {
    const { t } = useTranslations();
    const headingId = useComponentId('order-vas-heading');

    return (
        <VasBlockContainer
            data-test={dataTest}
            aria-labelledby={headingId}
            aria-label={t['eshop.product_page.vas.rate_plan_block.title']}
        >
            {vasList.map(({ iconType, title }, index) => (
                <TextWithIcon key={index}>
                    <IconMd svg={getSvgIcon(iconType)} />
                    <span>{title}</span>
                </TextWithIcon>
            ))}
        </VasBlockContainer>
    );
};
